"use client";
import { useEffect, useState } from "react";
import { fetchPromotions } from "@/lib/api/promotions";
import type { PromotionData } from "@/lib/promotion-types";
import { useDataScope } from "@/app/context/DataScopeContext";

const EMPTY: PromotionData = { actions: [], byOffer: {}, minActionPrice: {}, candidates: {}, candidatePrices: {} };

export function usePromotions(refreshKey?: number | null, enabled = true) {
  const [promoData, setPromoData] = useState<PromotionData>(EMPTY);
  const [promoLoading, setPromoLoading] = useState(false);
  const { scopeQuery, scopeReady } = useDataScope();

  useEffect(() => {
    if (!enabled) {
      setPromoData(EMPTY);
      setPromoLoading(false);
      return;
    }
    if (!scopeReady) {
      setPromoLoading(false);
      return;
    }
    setPromoLoading(true);
    fetchPromotions(scopeQuery)
      .then(data => setPromoData(data))
      .catch(err => console.error("[usePromotions]", err))
      .finally(() => setPromoLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshKey, scopeQuery, scopeReady, enabled]);

  return { promoData, promoLoading };
}
